// Intersection Observer to handle animations on scroll ------------------------------------------- //

export function init() {
  const elementsToObserve = document.querySelectorAll(".-intersectable");

  if (window.innerWidth > 650) {
    const handleIntersection = (entries, observer) => {
      entries.forEach((e) => {
        if (e.isIntersecting) e.target.classList.add("-intersected");
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1,
    });
    elementsToObserve.forEach((el) => {
      if (lazyLoad == false) {
        el.classList.add("-intersected");
      } else {
        observer.observe(el);
      }
    });
  }

  if (navigator.userAgent.indexOf("Trident") > -1 || window.innerWidth <= 650) {
    console.log("trigger all animations");

    Array.prototype.forEach.call(elementsToObserve, function (el) {
      el.classList.add("-intersected");
    });
  }

  if (document.querySelector(".down-arrow a")) {
    document.querySelector(".down-arrow a").addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo(0, 500);
    });
  }
}
